import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-118" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-119" data-mp="9tbbwq28ocf4">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border-2 border-prevention bg-white p-8 shadow-card sm:p-12" data-id="element-120" data-mp="etfx2te3dvbo">
          <span className="inline-flex rounded-full bg-prevention p-4 text-white" data-id="element-121" data-mp="slvthbchmv3m">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-122" data-mp="xkgw1hf7pqv8" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-123" data-mp="12ja58xnguvpl">Garantía de 7 días, sin preguntas</h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-124" data-mp="17j6dxa73zbbh">
            Abrís los tomos. Los usás en el aula, taller o laboratorio. Si en 7 días no es lo que esperabas, solicitás tu
            devolución.
          </p>
          <p className="mt-6 rounded-lg bg-preventionSoft px-5 py-4 text-lg font-extrabold text-prevention" data-id="element-125" data-mp="20r98pazlr0s3">
            Devolución del 100% sin formularios, sin drama.
          </p>
          <p className="mt-5 text-xs font-bold uppercase tracking-[.14em] text-muted" data-id="element-126" data-mp="1rt7bl6izosa3">Tasa de devoluciones: menos del 1%</p>
        </motion.div>
      </div>
    </section>;
}